export function getView(is_admin, app_company_status) {
  if (!is_admin) return 'No'
  if (app_company_status !== 'granted') return 'Install'
  return 'Manage'
}
